import { initialCurrentSpaceState, type CurrentSpaceState } from './slices/current/initial-state';
import { initialPrivateSpaceState, type PrivateSpaceState } from './slices/private/initial-state';

export type WorkspaceState = CurrentSpaceState & PrivateSpaceState;

export const initialState: WorkspaceState = {
  ...initialCurrentSpaceState,
  ...initialPrivateSpaceState,
};
